import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ContentCut from '@mui/icons-material/ContentCut';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPaste from '@mui/icons-material/ContentPaste';
import View from '@mui/icons-material/Visibility';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import Access from '@mui/icons-material/SubtitlesOff';
import Password from '@mui/icons-material/Key';
import Cloud from '@mui/icons-material/Cloud';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { getstaff } from '../redux/staff';

export default function IconMenu(props) {
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const dispatch = useDispatch();

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleLoginAccessChange = async (e) => {
    const newValue = e.target.checked;
    if (props.onLoginAccessChange) {
      props.onLoginAccessChange(newValue);
    }
    setLoading(true);
    try {
      const res = await axios.post('https://embert.sisrevolution.com/api/staff/editstaff', {
        _id: props.chosen._id,
        canLogin: newValue
      });
      console.log(res)
      if (res.status === 200 && res.data) {
        setSnackbarMessage('Login access updated successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
        dispatch(getstaff({ data: res.data }));
      }
    } catch (error) {
      setSnackbarMessage('Failed to update login access.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      console.error('Failed to update login access:', error);
    } finally {
      setLoading(false);
    }
  };

  console.log(props)

  return (
    <Paper sx={{ width: 320, maxWidth: '100%' }}>

      
      {/* Switch for Login Access */}
      <div style={{ display: 'flex', alignItems: 'center', padding: '16px' }}>
        <Typography variant="body1" sx={{ marginRight: 2 }}>
          Login Access
        </Typography>
        <input
          type="checkbox"
          checked={props.chosen.canLogin}
          onChange={handleLoginAccessChange}
          disabled={loading}
          style={{ width: 40, height: 20 }}
        />
        {loading && <CircularProgress size={20} sx={{ marginLeft: 1 }} />}
        <Typography variant="body2" sx={{ marginLeft: 1 }}>
          {props.loginAccess ? "Enabled" : "Disabled"}
        </Typography>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <MenuList>
        <MenuItem onClick={props.view}>
          <ListItemIcon>
            <View fontSize="small" />
          </ListItemIcon>
          <ListItemText>View</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘X */}
          </Typography>
        </MenuItem>
        <MenuItem onClick={props.permission}>
          <ListItemIcon>
            <Access fontSize="small" />
          </ListItemIcon>
          <ListItemText>Permission</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘C */}
          </Typography>
        </MenuItem>
        <MenuItem onClick={props.edit}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘C */}
          </Typography>
        </MenuItem>

         <MenuItem onClick={props.resetpassword}>
                  <ListItemIcon>
                    <Password fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Reset Password</ListItemText>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {/* ⌘C */}
                  </Typography>
                </MenuItem>

        <MenuItem onClick={props.delete}>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘V */}
          </Typography>
        </MenuItem>
        {/* <Divider />
        <MenuItem>
          <ListItemIcon>
            <Cloud fontSize="small" />
          </ListItemIcon>
          <ListItemText>Web Clipboard</ListItemText>
        </MenuItem> */}
      </MenuList>
    </Paper>
  );
}
